import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const LearningLabs = () => {
  const [learningLabs, setLearningLabs] = useState([]);

  useEffect(() => {
    fetchLearningLabs();
  }, []);

  const fetchLearningLabs = async () => {
    const res = await facilitiesAPI.learning_labs();

    if (res.code === 200) {
      const result = res.data;
      setLearningLabs(res.data?.["learning-labs"] || []);
    }
  };

  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Learning Labs"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {learningLabs && learningLabs.length > 0 && (
        <section className="science-labs-section py-5 ">
          <div className="container">
            <div className="row justify-content-start text-center mb-3">
              <div className="col-lg-12">
                <h2 className="mrv-title">World-Class Learning Labs</h2>
                <p className="mrv-desc">
                  Our school provides well-equipped learning laboratories that
                  encourage experimentation, innovation, and practical
                  understanding. These labs help students explore concepts
                  beyond textbooks and develop analytical and problem solving
                  skills.
                </p>
              </div>
            </div>
            <div className="portrait-grid">
              {learningLabs.map((lab, index) => (
                <div key={lab.id || index} className="portrait-card">
                  <div className="card-inner">
                    <img src={lab?.image} alt={lab.type} className="card-img" loading="lazy" />
                    <div className="card-content-wrapper">
                      <div className="card-info">
                        <span className="lab-category">{lab.tags}</span>
                        <h4 className="lab-title">{lab.type}</h4>
                        <p className="lab-text">{lab.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default LearningLabs;
